module.exports = __webpack_public_path__ + "static/img/2.cd3091c5.png";